module.exports = __webpack_public_path__ + "static/media/blom-a-generative-art-series-by-lucastswick-861.aa041d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom/blom-a-generative-art-series-by-lucastswick-861.jpg
// module id = 2962
// module chunks = 15